import { Component } from '@angular/core';
import { SpinnerService } from './_services/spinnerService';
import { Router } from '@angular/router';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.less'],
})

export class AppComponent {
    constructor(private router: Router, public spinnerService: SpinnerService) { }
    navigateToHome() {
        this.router.navigate(['/']);
    }
}
